import * as i0 from '@angular/core';
import { InjectionToken, Injectable, Inject, NgModule } from '@angular/core';

const WINDOW = new InjectionToken('Window');

const SE_FE_DOMAIN_ENVIRONMENT_OPTIONS = new InjectionToken('SeFeDomainEnvironmentOptions');

class SeFeDomainEnvironmentService {
    constructor(options, windowRef) {
        this.options = options;
        this.windowRef = windowRef;
        this._window = this.windowRef;
    }
    getUrl(urlKey) {
        const domainEnvironment = this.getDomainEnvironment();
        // If no domain environment found and no default,
        // use vanity domain suffixed with '/apigateway/' (e.g. - https://www.bysafl.com/apigateway)
        if (!domainEnvironment?.urls) {
            return `https://${this._window.location.hostname}/apigateway/`;
        }
        if (!domainEnvironment.urls[urlKey]) {
            console.error(`Error: No ${urlKey} url in environment ${domainEnvironment.domain}`);
            return undefined;
        }
        return this.ensureTrailingSlash(domainEnvironment.urls[urlKey]);
    }
    getDomainEnvironment() {
        const fullDomainMatch = this.options.domainEnvironments.find(data => {
            return data.domain.localeCompare(this._window.location.hostname, undefined, { sensitivity: 'base' }) === 0;
        });
        if (fullDomainMatch)
            return fullDomainMatch;
        const ancestorDomainMatch = this.options.domainEnvironments.find(data => {
            const re = new RegExp(`(^|\.)${data.domain}$`);
            return re.test(this._window.location.hostname);
        });
        if (ancestorDomainMatch)
            return ancestorDomainMatch;
        return this.options.domainEnvironments.find(data => data.default);
    }
    ensureTrailingSlash(url) {
        return url.endsWith('/') ? url : `${url}/`;
    }
}
SeFeDomainEnvironmentService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: SeFeDomainEnvironmentService, deps: [{ token: SE_FE_DOMAIN_ENVIRONMENT_OPTIONS }, { token: WINDOW }], target: i0.ɵɵFactoryTarget.Injectable });
SeFeDomainEnvironmentService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: SeFeDomainEnvironmentService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: SeFeDomainEnvironmentService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [SE_FE_DOMAIN_ENVIRONMENT_OPTIONS]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [WINDOW]
                }] }]; } });

class SeFeDomainEnvironmentModule {
    static forRoot(options) {
        return {
            ngModule: SeFeDomainEnvironmentModule,
            providers: [
                {
                    provide: SE_FE_DOMAIN_ENVIRONMENT_OPTIONS,
                    useValue: options,
                },
            ],
        };
    }
}
SeFeDomainEnvironmentModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: SeFeDomainEnvironmentModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
SeFeDomainEnvironmentModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: SeFeDomainEnvironmentModule });
SeFeDomainEnvironmentModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: SeFeDomainEnvironmentModule, providers: [{ provide: WINDOW, useValue: window }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: SeFeDomainEnvironmentModule, decorators: [{
            type: NgModule,
            args: [{
                    providers: [{ provide: WINDOW, useValue: window }],
                }]
        }] });

/*
 * Public API Surface of se-fe-domain-environment
 */

/**
 * Generated bundle index. Do not edit.
 */

export { SE_FE_DOMAIN_ENVIRONMENT_OPTIONS, SeFeDomainEnvironmentModule, SeFeDomainEnvironmentService, WINDOW };
